<div class="bg-white">
  <app-citizen-header></app-citizen-header>
  <div class="w-11/12 mx-auto">
    <app-shared-portal-services-list (searchKeyWord)="onSearch($event)"
                                     (paginate)="paginate($event)">
      <ng-template>
        <div class=" py-3 mx-auto px-2">
          @if (showFilter) {
            <app-service-filter-banner (formData)="onFormData($event)" ></app-service-filter-banner>
          } @else {
            <app-service-statistics-banner></app-service-statistics-banner>
          }
        </div>
      </ng-template>
    </app-shared-portal-services-list>
  </div>
  <app-portal-footer></app-portal-footer>
</div>
